import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URI || 'http://localhost:5555/api/';

const axiosClient = axios.create({
    baseURL: `${apiUrl}`,
    headers: {
        'content-type': 'application/json',
    },
});

axiosClient.interceptors.request.use(async (config) => {
    const customHeaders = {
        Authorization: '',
    };

    const token = localStorage.getItem('access_token');
    if (token) {
        customHeaders.Authorization = `Bearer ${token}`;
    }

    return {
        ...config,
        headers: {
            ...customHeaders, // auto attach token
            ...config.headers, // but you can override for some requests
        },
    };
});

axiosClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error?.response?.status === 401) {
            window.location.href = '/login';
            localStorage.removeItem('access_token');
            localStorage.removeItem('profile');
        } else {
            throw error?.response;
        }
    },
);

export default axiosClient;
